<template>
  <div class="content-wrap">
    <div class="first-line">
      <div>
        <viewer :images="baseData.workslist">
          <el-carousel
            :autoplay="false"
            @change="carChangeEvent"
            class="carousel-wrap"
            ref="carousel"
          >
            <el-carousel-item
              v-for="(item, index) in baseData.workslist"
              :key="index"
            >
              <div class="img-wrap">
                <img
                  :src="
                    baseData.recommend === '500px'
                      ? `https://images.weserv.nl/?url=${item}&h=820&fit=outside`
                      : `${item}?x-oss-process=image/resize,p_25`
                  "
                  alt=""
                  ref="bannerHeight"
                />
              </div>
            </el-carousel-item>
          </el-carousel>
        </viewer>
      </div>
      <div>
        <div class="desc-item">
          <h1 class="worksname">
            {{ baseData.author }} {{ baseData.worksname }}
          </h1>
          <p class="worksIntroduce">{{ baseData.worksIntroduce }}</p>
        </div>

        <div class="btn-wrap">
          <div class="vote-check-wrapper">
            <el-checkbox
              class="vote-check"
              v-model="baseData.isChecked"
              @change="voteChangeEvent($event, baseData)"
              >选择当前作品</el-checkbox
            >
          </div>
          <BaseButton @click="voteEvent">投票</BaseButton>
        </div>
      </div>
    </div>

    <div class="second-line">
      {{ activeIndex + 1 }}/{{
        baseData.workslist ? baseData.workslist.length : 0
      }}
    </div>

    <div class="works-pre">
      <div
        class="works-pre-item"
        v-for="(item, index) in baseData.workslist"
        :class="{ active: activeIndex === index }"
        :key="index"
        @click="setCarEvent(index)"
        :style="{
          background: $store.state.env.isIE
            ? baseData.recommend === '500px'
              ? `https://images.weserv.nl/?url=${item}&h=900&fit=outside`
              : `url(${item}?x-oss-process=image/resize,p_25) no-repeat center`
            : '',
          backgroundSize: $store.state.env.isIE ? `cover` : '',
        }"
      >
        <img
          v-if="!$store.state.env.isIE"
          :src="
            baseData.recommend === '500px'
              ? `https://images.weserv.nl/?url=${item}&h=900&fit=outside`
              : `${item}?x-oss-process=image/resize,p_25`
          "
          alt=""
        />
        <div class="mask"></div>
      </div>
      <div class="share-container">
        <div class="share-wrap" v-if="$route.name === 'WorksDetails'">
          <div class="share-text">点击分享:</div>
          <el-popover placement="top" width="200" trigger="hover">
            <div class="qrcode"></div>
            <div
              class="share-icon"
              @click="shareEvent('wechat')"
              slot="reference"
              :style="{
                backgroundImage: `url(${require(`@/assets/img/share/${'wechat'}.png`)})`,
              }"
              @mouseover="createQRCodeFn"
            ></div>
          </el-popover>
          <div
            v-for="(item, index) in shareIcon"
            :key="index"
            class="share-icon"
            :class="{ 'copy-url': item === 'url' }"
            @click="shareEvent(item)"
            :style="{
              backgroundImage: `url(${require(`@/assets/img/share/${item}.png`)})`,
            }"
          ></div>
        </div>
      </div>
    </div>

    <!-- <div class="carousel-wrap">
      <div v-for="(item, index) in workslist" :key="index">
        <img :src="item" alt="" />
      </div>
    </div> -->
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import worksApi from "@/api/works";
import { microBlog } from "@/utils/share";
import ClipboardJS from "clipboard";
let clip;
export default {
  name: "WorksDetailsMain",
  data() {
    return {
      id: null,
      activeIndex: 0,
      baseData: {
        // workslist: [
        //   "https://static.veer.com/veer/static/resources/keyword/2020-02-19/533ed30de651499da1c463bca44b6d60.jpg",
        //   "https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=2835954585,4104520500&fm=26&gp=0.jpg"
        // ]
      },
      shareIcon: ["weibo", "url"],
    };
  },
  computed: {
    ...mapState(["selectedArr"]),
  },
  methods: {
    ...mapMutations(["setBreadcrumb", "setWorksDetails", "setSelectedArr"]),
    /**
     * 初始化数据
     */
    async fetchData(id) {
      let data = await worksApi.fetchWorksDetails(id);
      if (data.code === 200) {
        if (data.data.worksname) {
          let flag = this.selectedArr.indexOf(this.id);
          this.baseData = {
            isChecked: flag > -1 ? true : false,
            ...data.data,
            id: this.id,
          };
          this.setWorksDetails(data.data);
        } else {
          this.$router.push("/works");
        }
      }
      this.setBreadcrumb([
        // {
        //   title: "作品列表",
        //   url: "/works",
        // },
        {
          title: `${this.baseData.author} ${this.baseData.worksname}`,
        },
      ]);
    },
    /**
     * 监听跑买灯改变
     */
    carChangeEvent(index) {
      this.activeIndex = index;
    },
    /**
     * 设置跑马灯
     */
    setCarEvent(index) {
      this.activeIndex = index;
      this.$refs.carousel.setActiveItem(index);
    },
    /**
     * 分享
     */
    shareEvent(type) {
      if (type === "wechat" || type === "friends") {
      } else if (type === "weibo") {
        this.$root.$emit("weibo");
      }
    },

    /**
     * 生成二维码
     */
    createQRCodeFn() {
      let box = document.querySelector(".qrcode");
      box.innerHTML = "";
      if (box) {
        new QRCode(box, {
          text: location.href,
          width: 200,
          height: 200,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
      }
    },

    /**
     * 微博分享 主题框架在父组件
     */
    weiboShareFn() {
      let url = microBlog({
        author: this.baseData.author,
        worksname: this.baseData.worksname,
        url: location.href,
        pic: this.baseData.workslist[0],
      });
      window.open(encodeURI(url));
    },

    /**
     * 初始化复制链接
     */
    initCopyUrlFn() {
      let _this = this;
      this.$nextTick(() => {
        if (clip) {
          return;
        }
        clip = new ClipboardJS(".copy-url", {
          text: function (trigger) {
            _this.$message.success("链接复制成功");
            return location.href;
          },
        });
      });
    },

    /**
     * 打开子窗口
     */
    async voteEvent() {
      if (this.selectedArr.length === 0) {
        this.$message.warning("您还没有选择作品");
        return;
      }
      let token = localStorage.getItem("token");
      if (token) {
        let { code, msg } = await worksApi.voteWorks(this.selectedArr, token);
        if (code === 200) {
          this.$message.success("投票成功");
          this.clearSelectedFn();
          if (this.baseData.isChecked) {
            this.baseData.isChecked = false;
          }
        } else if (code === 201) {
          this.$message.warning(msg);
          this.clearSelectedFn();
          if (this.baseData.isChecked) {
            this.baseData.isChecked = false;
          }
        } else if (code === 4018) {
          localStorage.removeItem("token");
        }
      } else {
        window.open(
          "/syhqds2022/wechat-login.html",
          "_blank",
          "width=700, height=500, left=200"
        );
      }
    },
    /**
     * 选择作品
     */
    voteChangeEvent(status, obj) {
      if (this.selectedArr.length >= 5 && status) {
        setTimeout(() => {
          obj.isChecked = false;
        }, 100);
        this.$message.warning("您已经选择5副作品啦！");
      } else {
        this.setSelectedArr({ status, value: obj.id });
      }
    },
    /**
     * 投票成功清空选择
     */
    clearSelectedFn() {
      this.setSelectedArr([]);
    },
  },
  destroyed() {
    this.$root.$off("weibo");
  },
  created() {
    let id = this.$route.params.id;
    if (id) {
      this.id = Number(id);
      this.fetchData(id);
      this.$root.$on("weibo", () => {
        this.weiboShareFn();
      });
    } else {
      this.$router.push("/works");
    }
  },
  mounted() {
    this.createQRCodeFn();
    this.initCopyUrlFn();
  },
};
</script>
<style lang="scss" scoped>
.content-wrap {
  width: 100%;
  margin: 30px 7px 120px;
  .first-line {
    display: flex;
    align-items: flex-start;
    & > div:first-child {
      width: 1230px;
      height: 820px;
      margin-right: 50px;
    }
    & > div:last-child {
      width: 320px;
      height: 820px;
      display: flex;
      flex-direction: column;
      .desc-item {
        width: 100%;
        max-height: 600px;
        margin-bottom: auto;
        .worksname {
          // margin: 30px auto 20px;
          text-align: left;
          font-size: 18px;
          // line-height: 30px;
          margin-bottom: 30px;
          font-weight: bold;
        }
        .worksIntroduce {
          font-size: 16px;
          line-height: 30px;
          color: $color-text-primary;
          overflow: auto;
        }
      }
      .btn-wrap {
        display: flex;
        align-items: center;
        margin-top: 0;
        margin-bottom: 0;
        .vote-check-wrapper {
          margin-right: 40px;
        }
        ::v-deep .el-checkbox__label {
          vertical-align: middle;
          color: $color-text-regular;
        }
        ::v-deep .el-checkbox__inner {
          width: 17px;
          height: 17px;
          border-color: $color-text-regular;
          &::after {
            left: 5.5px;
            top: 2.5px;
          }
          &:hover {
            border-color: #ffc15e;
          }
        }
        ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
          background: #ffc15e;
          border-color: #ffc15e;
        }
        ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
          border-color: #ffc15e;
        }
      }
    }
  }
  .second-line {
    margin: 40px 7px;
    width: 1230px;
    text-align: center;
    font-size: 18px;
  }
}
img {
  display: block;
}
.carousel-wrap {
  & /deep/ .el-carousel__container {
    height: 820px;
  }
  .img-wrap {
    height: 100%;
    img {
      margin: 0 auto;
      height: 100%;
      max-width: 100%;
      cursor: pointer;
      object-fit: contain;
    }
  }
}

.works-pre {
  // margin: 55px auto 0;
  display: flex;
  align-items: flex-end;
  .works-pre-item {
    width: 238px;
    height: 160px;
    border-radius: 5px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    & + .works-pre-item {
      margin-left: 10px;
    }
    .mask {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      transition: 0.4s;
    }
    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .share-container {
    width: 320px;
    margin-left: auto;
    margin-right: 0;
    display: flex;
    justify-content: flex-end;
    .share-wrap {
      display: flex;
      align-items: center;
      > .selected {
        font-size: 16px;
        // vertical-align: -8px;
        display: flex;
        align-items: center;
        color: $color-primary;
        margin-right: 14px;
        svg {
          width: 24px;
          height: 32px;
          vertical-align: -4px;
          > path {
            fill: $color-primary;
          }
        }
        span {
          margin-left: 8px;
        }
        ::v-deep .el-badge__content.is-fixed {
          top: 4px;
          right: 14px;
        }
        ::v-deep .el-badge__content {
          background-color: #d4003b;
        }
      }
      .share-text {
        font-size: 16px;
        color: $color-text-primary;
        margin-right: 5px;
      }
      .share-icon {
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
        width: 24px;
        height: 24px;
        margin-left: 10px;
      }
      .qrcode {
        box-shadow: 0 0 0 #000000;
      }
    }
  }
  .active {
    cursor: default;
    .mask {
      opacity: 0;
    }
  }
}
</style>